module.exports = __webpack_public_path__ + "img/jerusalem.7db8bc5b.jpg";